module.exports = __webpack_public_path__ + "img/logo-lg.adb6ec17.png";